import * as React from 'react';
import CookieBanner from '../CookieBanner';
import FooterContent from '../FooterContent';
import TellUsMore from '../TellUsMore';
import Facebook from '../icons/Facebook';
import Instagram from '../icons/Instagram';
import LinkedIn from '../icons/LinkedIn';
import './style.scss';
import ScrollToTopButton from '../ScrollToTopButton';
import { useTranslation } from 'react-i18next';
import { FOOTER_TEXTS } from '../../theme/footer';

const Footer: React.SFC<{
  noFooterCard: boolean;
  onTellUsMoreClick?: () => void;
  isLegacy?: boolean;
}> = ({ noFooterCard, onTellUsMoreClick, isLegacy = true }) => {
  const { t } = useTranslation();

  return (
    <footer>
      {!noFooterCard ? <TellUsMore onClick={onTellUsMoreClick} /> : null}
      <FooterContent
        isLegacy={isLegacy}
        noFooterCard={noFooterCard}
        siteMap={FOOTER_TEXTS.map((item) => ({
          title: t(item.title),
          links: item.links.map((link) => ({
            title: t(link.title),
            href: t(link.href),
          })),
        }))}
        networking={[
          { icon: Facebook, href: 'https://www.facebook.com/stormotion/' },
          {
            icon: Instagram,
            href: 'https://www.instagram.com/stormotion_team/',
          },
          {
            icon: LinkedIn,
            href: 'https://www.linkedin.com/company/stormotion/',
          },
        ]}
      />
      <CookieBanner />
      <ScrollToTopButton />
    </footer>
  );
};

export default Footer;
